import React from "react";
import {addToBookList} from "./action/books";
import {connect} from "react-redux";

class AlterBooks extends React.Component{
    state={
        loading: false
    }
    addToBookList = e=>{;
        this.setState({loading: true});
        this.props.addToBookList({bookListId: this.props.match.params.bookId, total_noof_books: this.props.bookLists[this.props.match.params.bookId].total_noof_books+1, bookId: e.target.id}).then(msg => {
            this.setState({loading: false})
            // this.props.history.push("/main/bookLists")
        }).catch(msg => {
            this.setState({loading: false})
        })
    };
    render(){
        const {addToBookList} = this;
        return(
            <div>
                <h1 className="content_title">Alter Books</h1>
                {this.state.loading && (
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    )}
                {this.props.books && this.props.books.map(function(item){
                    return <h1 className="alterBtn" onClick={addToBookList} id={item.bookId} title={item.book_title}>{item.book_title}</h1>
                })}
            </div>
        );
    };
};

function mapStateToProps(state){
    return {books: state.AllBooks.books, bookLists: state.AllBooklists.bookLists}
}

export default connect(mapStateToProps, {addToBookList})(AlterBooks);